// src/components/Sidebar.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import './Sidebar.css';
import { FaCog } from 'react-icons/fa'; // ⚙️ Settings icon

function Sidebar({ role = 'engineer', buttons = [] }) {
  const navigate = useNavigate();

  const roles = {
    admin: [
      { label: 'Dashboard', path: '/admin-dashboard' },
      { label: 'Projects', path: '/projects' },
      { label: 'Custom Reports', path: '/custom-reports' }
    ],
    engineer: [
      { label: 'Dashboard', path: '/engineer-dashboard' },
      { label: 'Projects', path: '/projects' },
      { label: 'Custom Reports', path: '/custom-reports' }
    ],
    owner: [
      { label: 'Dashboard', path: '/owner-dashboard' },
      { label: 'Projects', path: '/projects' },
      { label: 'Custom Reports', path: '/custom-reports' }
    ]
  };

  const navButtons = roles[role] || roles['engineer'];
  const dynamicButtons = buttons.filter((b) => !b.special);
  const actionButtons = buttons.filter((b) => b.special);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };

  return (
    <div className="sidebar">
      {/* ✅ Reference to logo now from /public/ */}
      <img src="/VilanoLogo.png" alt="Logo" className="sidebar-logo" />

      <button
        className="sidebar-button"
        onClick={() => navigate('/settings')}
        style={{
          backgroundColor: 'silver',
          color: 'black',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <FaCog style={{ marginRight: '8px' }} />
        Settings
      </button>

      {[...navButtons, ...dynamicButtons].map((button, index) => (
        <button
          key={index}
          className="sidebar-button"
          onClick={() => {
            if (button.action) {
              button.action();
            } else if (button.path) {
              navigate(button.path);
            }
          }}
        >
          {button.label}
        </button>
      ))}

      <div className="sidebar-spacer" />

      {actionButtons.map((button, index) => (
        <button
          key={index}
          className="sidebar-action-button"
          onClick={button.action}
        >
          {button.label}
        </button>
      ))}

      <button className="sidebar-signout" onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  );
}

export default Sidebar;
